import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function brazilMobileValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || !value.number) return null; // no value, no error

    const countryCode = value.countryCode || '';
    const numeric = value.number.replace(/\D/g, '');

    // Only validate if country code is Brazil
    if (countryCode.toUpperCase() === 'BR' || numeric.startsWith('55')) {
      // Ensure starts with 55
      const normalized = numeric.startsWith('55') ? numeric : '55' + numeric;

      // Area code
      const areaCode = parseInt(normalized.substr(2, 2), 10);
      if (areaCode < 11 || areaCode > 99) {
        return { brazilMobile: 'Invalid area code' };
      }

      // Mobile number
      const mobileNumber = normalized.substr(4);
      if (mobileNumber.length !== 9) {
        return { brazilMobile: 'Mobile number must have 9 digits' };
      }
      if (!mobileNumber.startsWith('9')) {
        return { brazilMobile: 'Mobile number must start with 9' };
      }
    }

    // Any other country: no Brazil-specific validation
    return null;
  };
}
